/// <reference path="../modules/app.module.ts"/>
/// <reference path="blocks.exception.factory.ts" />
/// <reference path="../objects/interfaces/ihttphelper.ts" />

module App {
    export class HttpHelper implements IHttpHelper {
        static factoryId = "httpHelperFactory";

        constructor(private $http: ng.IHttpService, private $q: ng.IQService, private exception: Blocks.IExceptionService) {
            
        }

        get = <T>(url: string, postValues?: any, extraHeaders?: { [key: string]: any }, extraProperties?: { [key: string]: any }): ng.IPromise<T> => {
            return this.makeCall<T>(url, Constants.httpMethods.GET, postValues, extraHeaders, extraProperties);
        }

        post = <T>(url: string, postValues?: any, extraHeaders?: { [key: string]: any }, extraProperties?: { [key: string]: any }): ng.IPromise<T> => {
            return this.makeCall<T>(url, Constants.httpMethods.POST, postValues, extraHeaders, extraProperties);
        }

        makeCall = <T>(url: string, method: string, postValues?: any, extraHeaders?: { [key: string]: any }, extraProperties?: { [key: string]: any }): ng.IPromise<T> => {
            var request: ng.IRequestConfig = {
                cache: false,
                method: method,
                url: url,
                data: postValues,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            if (extraHeaders) {
                for (var item in extraHeaders) {
                    request.headers[item] = extraHeaders[item];
                }
            }
            if (extraProperties) {
                for (var item in extraProperties) {
                    request[item] = extraProperties[item];
                }
            }

            return this.$http(request)
                .then((response) => {
                    if (response.status == 200) {
                        return <T>(response.data);
                    }
                    var deferred = this.$q.defer<T>();

                    deferred.reject(response);

                    return deferred.promise;
                }).catch((err) => {
                    return err;
                });
        }
    }

    app.factory(HttpHelper.factoryId, ['$http', '$q', Blocks.ExceptionService.factoryId, ($http, $q, exception) => new HttpHelper($http, $q, exception)]);
}